import { map } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { Retry } from '@services/decorators/retry.decorator'
import { HttpClient } from '@angular/common/http'
import { ManagementApiBaseService } from '@services/api/management-api-base.service'
import {
	SupplierEnrollmentNoticeAdjusted,
	SupplierEnrollmentNoticeAdjustedSearch,
	SupplierEnrollmentNoticeAdjustedRequest,
	SupplierEnrollmentNoticeAdjustedAnswerRequest
} from '@models/supplier/notice/proposal/supplier-enrollment-notice-adjusted.model'
import { BaseResponse } from '@services/api/api-base.service'
@Injectable({
	providedIn: 'root'
})
export class SupplierEnrollmentNoticeAdjustedService extends ManagementApiBaseService<SupplierEnrollmentNoticeAdjustedSearch> {
	private readonly source: string

	constructor(override http: HttpClient) {
		super(http)
		this.sortColumn = 'createdAt'
		this.source = 'supplier-enrollment-notice-adjusted-proposals'
		this.searchTerm = new SupplierEnrollmentNoticeAdjustedSearch()
	}

	save(request: SupplierEnrollmentNoticeAdjustedRequest) {
		return this.post<SupplierEnrollmentNoticeAdjustedRequest, SupplierEnrollmentNoticeAdjusted>(`${this.source}`, request).pipe(
			map(response => new BaseResponse({ id: response.id }))
		)
	}

	latest(sessionId: string, enrollmentId: string) {
		return this.get<SupplierEnrollmentNoticeAdjusted>(`${this.source}/latest/${sessionId}/${enrollmentId}`).pipe(
			map(response => new SupplierEnrollmentNoticeAdjusted(response))
		)
	}

	listable(sessionId: string, enrollmentId: string) {
		return this.get<Array<SupplierEnrollmentNoticeAdjusted>>(`${this.source}/${sessionId}/${enrollmentId}`).pipe(
			map(response => response.map(it => new SupplierEnrollmentNoticeAdjusted(it)))
		)
	}

	@Retry(3)
	opened(id: string, description?: string) {
		return this.patch<any>(`${this.source}/opened`, { id, description })
	}

	@Retry(3)
	closed(id: string, description?: string) {
		return this.patch<any>(`${this.source}/closed`, { id, description })
	}

	@Retry(3)
	answer(request: SupplierEnrollmentNoticeAdjustedAnswerRequest) {
		return this.patch<any>(`${this.source}/answers`, request)
	}
}
